import { CustomEventName } from '@/constants';
import type { LoginState } from '@/interfaces';
import { resetDataLayerAndPushEvent } from '..';

export const gtmViewNotified = (loginState: LoginState, variant?: string) => {
  resetDataLayerAndPushEvent(CustomEventName.ViewNotified, {
    loginState,
    variant,
  });
};

export const gtmClickNotified = (loginState: LoginState, variant?: string) => {
  resetDataLayerAndPushEvent(CustomEventName.ClickNotified, {
    loginState,
    variant,
  });
};

export const gtmClickEmailCta = () => {
  resetDataLayerAndPushEvent(CustomEventName.ClickEmailCta);
};

// TODO: Add new params to match with requirement of Phoenix 04
export const gtmUnsubSummaryEmail = () => {
  resetDataLayerAndPushEvent(CustomEventName.UnsubSummaryEmail);
};

export const gtmResubSummaryToggle = () => {
  resetDataLayerAndPushEvent(CustomEventName.ResubSummaryToggle);
};
